const DataUpdateQueue = (): void => {
  throw new Error('Data Update Queue is not implemented on web');
};

export default DataUpdateQueue;
